import Component from './Rate';

import { connect } from 'react-redux';

// on map le state de redux sur les props du composant
const mapStateToProps = (state) => {
  // const {globalKey,flow} = state.app;

  const choices = [
    {
      id: 'rate1',
      label: '1',
      value: 1
    },
    {
      id: 'rate2',
      label: '2',
      value: 2
    },
    {
      id: 'rate3',
      label: '3',
      value: 3
    },
    {
      id: 'rate4',
      label: '4',
      value: 4
    },
    {
      id: 'rate5',
      label: '5',
      value: 5
    }
  ];

  return {
    choices
  };
};

export default connect(mapStateToProps, undefined)(Component);
